import AssignmentIcon from '@mui/icons-material/Assignment';
import BusinessIcon from '@mui/icons-material/Business';
import GroupIcon from '@mui/icons-material/Group';
import InsightsIcon from '@mui/icons-material/Insights';
import LogoutIcon from '@mui/icons-material/Logout';
import NotificationsIcon from '@mui/icons-material/Notifications';
import SmartToyIcon from '@mui/icons-material/SmartToy';
import DeblurIcon from '@mui/icons-material/Deblur';
import Diversity3Icon from '@mui/icons-material/Diversity3';
import QuizIcon from '@mui/icons-material/Quiz';

import i18next from '../../translations/i18n';
import { AdminRole } from '../../types/admins.type';
import ImpactReportIcon from '@mui/icons-material/Newspaper';

const getSidebarConfig = () => {
  const roles = JSON.parse(localStorage.getItem('roles') || '[]');

  const isAdmin = roles.includes(AdminRole.ADMIN);

  return [
    {
      subheader: i18next.t('sidebar.menuHeaderPages'),
      items: [
        {
          title: i18next.t('sidebar.menuItemAdmins'),
          path: '/admins',
          icon: <GroupIcon />,
          visible: isAdmin,
        },
        {
          title: i18next.t('sidebar.menuItemUsers'),
          path: '/users',
          icon: <GroupIcon />,
          visible: isAdmin || roles.includes(AdminRole.USER_MANAGER),
        },
        {
          title: i18next.t('sidebar.menuItemOrganisations'),
          path: '/organisations',
          icon: <BusinessIcon />,
          visible: isAdmin,
        },
        {
          title: i18next.t('sidebar.menuItemGroups'),
          path: '/allgroups',
          icon: <Diversity3Icon />,
          visible: isAdmin,
        },
        {
          title: i18next.t('sidebar.menuItemCompobots'),
          path: '/compobots',
          icon: <SmartToyIcon />,
          visible: isAdmin || roles.includes(AdminRole.COMPOBOT_MANAGER),
        },{
          title: i18next.t('sidebar.menuItemGuiVersions'),
          path: '/gui-versions',
          icon: <DeblurIcon />,
          visible: isAdmin || roles.includes(AdminRole.COMPOBOT_MANAGER),
        },
        {
          title: i18next.t('sidebar.menuItemChallanges'),
          path: '/challenges',
          icon: <AssignmentIcon />,
          visible: isAdmin || roles.includes(AdminRole.CHALLENGE_MANAGER),
        },
        {
          title: i18next.t('sidebar.menuItemQuiz'),
          path: '/quiz',
          icon: <QuizIcon />,
          visible: isAdmin,
        },
        {
          title: i18next.t('sidebar.menuItemImpactReports'),
          path: '/impactReports',
          icon: <ImpactReportIcon />,
          visible: isAdmin,
        },
        {
          title: i18next.t('sidebar.menuItemNotifications'),
          path: '/notifications',
          icon: <NotificationsIcon />,
          visible: isAdmin,
        },
        {
          title: i18next.t('sidebar.menuItemLeads'),
          path: '/leads',
          icon: <InsightsIcon />,
          visible: isAdmin,
        },
      ].filter(item => item.visible),
    },
    {
      subheader: i18next.t('sidebar.menuHeaderOther'),
      items: [
        {
          title: i18next.t('sidebar.menuItemLogout'),
          path: '/',
          exact: true,
          icon: <LogoutIcon />,
          visible: true,
        },
      ],
    },
  ];
};

export default getSidebarConfig;